import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {CoverageAnalysisView} from '../rfi-coverage-analysis-dialog.types';
import {CoverageTabHeaderComponent} from '../coverage-tab-header/coverage-tab-header.component';
import {RfiCoverageBarComponent} from '../../rfi-coverage-bar/rfi-coverage-bar.component';

@Component({
  selector: 'app-coverage-countries-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    AppNumberPipe,
    TranslocoPipe,
    CoverageTabHeaderComponent,
    RfiCoverageBarComponent,
  ],
  templateUrl: './coverage-countries-tab.component.html',
})
export class CoverageCountriesTabComponent {
  readonly view = input.required<CoverageAnalysisView>();

  protected readonly titleParams = computed(() => ({count: this.view().countries.length}));
}
